import { render } from "./submissions-table-row.vue?vue&type=template&id=6838f25c&scoped=true&ts=true"
import script from "./submissions-table-row.vue?vue&type=script&lang=ts"
export * from "./submissions-table-row.vue?vue&type=script&lang=ts"

import "./submissions-table-row.vue?vue&type=style&index=0&id=6838f25c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6838f25c"]])

export default __exports__